import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const required = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
];

export function getFirebaseConfig() {
  const missing = required.filter((k) => !import.meta.env[k]);
  if (missing.length) return { ok: false, missing };
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };
  const measurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;
  if (measurementId) config.measurementId = measurementId;
  return { ok: true, config };
}

let app;
let auth;
let db;
let storage;
let fns;

export function initFirebase() {
  const result = getFirebaseConfig();
  if (!result.ok) return { ok: false, missing: result.missing };

  if (!getApps().length) {
    app = initializeApp(result.config);
    try {
      db = initializeFirestore(app, {});
    } catch (e) {
      console.warn('[Firebase] initializeFirestore falló, usando getFirestore:', e);
      db = getFirestore(app);
    }
  } else {
    app = getApps()[0];
    db = getFirestore(app);
  }
  auth = getAuth(app);
  storage = getStorage(app);
  fns = getFunctions(app, 'us-central1');

  return { ok: true, auth, db, storage, fns };
}

export function getFirebase() {
  return { auth, db, storage, fns };
}
